import { ProjectMap, Project, FOLD_STATE } from '../Components/ProjectTypes';
import ProjectComponentWrapper from "../Components/Project";
import { PhoneNumberState } from '../SiteState/SiteStateTypes';

function PhoneNumberLayout({ phoneNumber, projectMap, phoneNumberState }: { phoneNumber: number, projectMap: ProjectMap, phoneNumberState?: PhoneNumberState }) {
    if (!phoneNumberState) {
        return null;
    }

    const phoneNumberAsString = phoneNumber.toString();
    const phoneNumberFirst3 = phoneNumberAsString.substring(0, 3);
    const phoneNumberMiddle3 = phoneNumberAsString.substring(3, 6);
    const phoneNumberLast4 = phoneNumberAsString.substring(6);
    const phoneNumberString = `(${phoneNumberFirst3}) ${phoneNumberMiddle3}-${phoneNumberLast4}`

    return (
        <div style={{ width: "100%", height: "100%" }} className="phoneNumberLayout">
            <div className="phoneNumber">
                {phoneNumberString}
            </div>
            {Object.keys(projectMap).map((projectKey) => <ScrollingProject project={projectMap[projectKey]} />)}
        </div>
    );
}

function ScrollingProject({ project }: { project: Project }) {

    return (
        <div style={{ width: "100%", height: "100%" }} className="scrollingProject">
            <ProjectComponentWrapper foldState={FOLD_STATE.NAME} project={project} />
        </div>
    );
}

export default PhoneNumberLayout;
